import React, {lazy, Suspense} from "react"
import {Redirect, Route, Router, Switch} from "react-router-dom"
import {history} from "./history"
import {connect} from "react-redux"
import Spinner from "./components/loader/spinner"
import {ContextLayout} from "./utility/context/Layout"
import {store} from "./redux/storeConfig/store";
import {getPing} from "./redux/actions/auth/pingActions";
import ConnectionError from "./views/errors/ConnectionError";
import {getUI} from "./redux/actions/UI/uiActions";
import ScrollToTop from "./utility/ScrollToTop";

// Route-based System
const SystemDashboard = lazy(() =>
    import("./views/panel/system/SystemDashboard")
);
const SystemCategories = lazy(() =>
    import("./views/panel/system/SystemCategories")
);
const AdminStroies = lazy(() =>
    import("./views/panel/admin/AdminStories")
);
const galleryPanel = lazy(() =>
    import("./views/panel/admin/AdminGallery")
);
const SystemSections = lazy(() =>
    import("./views/panel/system/SystemSections")
);
const SystemMenu = lazy(() =>
    import("./views/panel/system/SystemMenu")
);
const SystemSlider = lazy(() =>
    import("./views/panel/system/SystemSlider")
);
const SystemCodeEditor = lazy(() =>
    import("./views/panel/system/SystemCodeEditor")
);

// Route-based Admin
const AdminDashboard = lazy(() =>
    import("./views/panel/admin/AdminDashboard")
);
const AdminCustomers = lazy(() =>
    import("./views/panel/admin/AdminCustomers")
);
const AdminSeller = lazy(() =>
    import("./views/panel/admin/AdminSeller")
);
const AdminContactForm = lazy(() =>
    import("./views/panel/admin/AdminContactForm")
);
const AdminOrders = lazy(() =>
    import("./views/panel/admin/AdminOrders")
);
const AdminInvoices = lazy(() =>
    import("./views/panel/admin/AdminInvoices")
);
const AdminProducts = lazy(() =>
    import("./views/panel/admin/AdminProducts")
);
const AdminPrices = lazy(() =>
    import("./views/panel/admin/AdminPrices")
);
const AdminProductCreateAndEdit = lazy(() =>
    import("./components/Panel/products/admin/ProductCreateAndEdit")
);
const AdminProductVariety = lazy(() =>
    import("./components/Panel/products/admin/ProductVariety")
);
const AdminCoupons = lazy(() =>
    import("./views/panel/admin/AdminCoupons")
);
const AdminSendGoods = lazy(() =>
    import("./views/panel/admin/AdminSendGoods")
);
const AdminProfile = lazy(() =>
    import("./views/panel/admin/AdminProfile")
);
const AdminComments = lazy(() =>
    import("./views/panel/admin/AdminComments")
);
const AdminArticleCategory = lazy(() =>
    import("./views/panel/admin/AdminCategoryArticles")
);
const AdminArticle = lazy(() =>
    import("./views/panel/admin/AdminArticleManagement")
);

// Route-based Seller
const SellerDashboard = lazy(() =>
    import("./views/panel/seller/SellerDashboard")
);
const SellerProducts = lazy(() =>
    import("./views/panel/seller/SellerProducts")
);
const SellerProductCreateAndEdit = lazy(() =>
    import("./components/Panel/products/seller/ProductCreateAndEdit")
);
const SellerProductVariety = lazy(() =>
    import("./components/Panel/products/seller/ProductVariety")
);
const SellerOrders = lazy(() =>
    import("./views/panel/seller/SellerOrders")
);

// Route-based Customer
const CustomerDashboard = lazy(() =>
    import("./views/panel/customer/CustomerDashboard")
);
const CustomerInterest = lazy(() =>
    import("./views/panel/customer/CustomerInterest")
);
const CustomerOrders = lazy(() =>
    import("./views/panel/customer/CustomerOrders")
);
const CustomerComments = lazy(() =>
    import("./views/panel/customer/CustomerComments")
);
const CustomerAddress = lazy(() =>
    import("./views/panel/customer/CustomerAddress")
);
const CustomerProfile = lazy(() =>
    import("./views/panel/customer/CustomerProfile")
);
const CustomerInvoices = lazy(() =>
    import("./views/panel/customer/CustomerInvoices")
);

// Route-based Web
const Web = lazy(() =>
    import("./views/web/home")
);
const Cart = lazy(() =>
    import("./views/web/cart")
);
const Shipping = lazy(() =>
    import("./views/web/shipping")
);
const Product = lazy(() =>
    import("./views/web/product")
);
const Category = lazy(() =>
    import("./views/web/category")
);
const Search = lazy(() =>
    import("./views/web/search")
);
const Articles = lazy(() =>
    import("./views/web/articles")
);
const Article = lazy(() =>
    import("./views/web/article")
);
const Rules = lazy(() =>
    import("./views/web/Rules")
);
/*const HowToBuy = lazy(() =>
    import("./views/web/HowToBuy")
);*/
const about_us = lazy(() =>
    import("./views/web/about_us")
);
const contact_us = lazy(() =>
    import("./views/web/contact_us")
);
const gallery = lazy(() =>
    import("./views/web/gallery")
);
// Route-Auth
const Login = lazy(() =>
    import("./views/authentication/login/")
);
// const Register = lazy(() =>
//     import("./views/authentication/register/")
// );
// const ForgotPass = lazy(() =>
//     import("./views/authentication/forgot_password/")
// );

//errors
const error404 = lazy(() =>
    import("./views/errors/404/index")
);

// Set Layout and Component Using App Route
const RouteConfig = ({component: Component, permission, fullLayout, ...rest}) => (
    <Route
        {...rest}
        render={props => {
            return (
                <ContextLayout.Consumer>
                    {context => {
                        let LayoutTag =
                            fullLayout === true
                                ? context.fullLayout
                                : context.state.activeLayout === "horizontal"
                                    ? context.horizontalLayout
                                    : context.VerticalLayout;
                        const view =
                            <LayoutTag {...props} permission={getUserRole(rest.user)}>
                                <Suspense fallback={<Spinner/>}>
                                    <Component {...props} />
                                </Suspense>
                            </LayoutTag>;
                        if (!!rest.user) {
                            if (permission)
                                return permission === getUserRole(rest.user) ? (
                                    view
                                ) : (
                                    <Redirect to={error404}/>
                                );
                            else
                                return (
                                    view
                                );
                        } else {
                            return (
                                <>
                                    <ConnectionError/>
                                    {view}
                                </>
                            );
                        }

                    }}
                </ContextLayout.Consumer>
            )
        }}
    />
)

const getUserRole = (user) => {
    if (user) {
        if (user.roles) {
            return user.roles;
        } else
            return "";
    } else
        return "";
}

const mapStateToProps = state => {
    return {
        user: state.auth
    }
}

const AppRoute = connect(mapStateToProps)(RouteConfig)

class AppRouter extends React.Component {
    componentWillMount() {
        let token = localStorage.getItem("token");
        if (token) {
            store.dispatch({
                type: "LOGIN",
                payload: token
            });
        }
        this.props.getPing();
        this.props.getUI();
    }


    render() {
        return (
            /* Permissions
               admin
               customer
               seller
               system
            */
            <Router history={history}>
                <ScrollToTop/>
                <Switch>
                    {/* Web Route*/}
                    <AppRoute exact path="/" component={Web} fullLayout/>
                    <AppRoute path="/cart" component={Cart} fullLayout/>
                    <AppRoute path="/shipping" permission="customer" component={Shipping} fullLayout/>
                    <AppRoute path="/product" component={Product} fullLayout/>
                    <AppRoute path="/category" component={Category} fullLayout/>
                    <AppRoute path="/authorize" component={Login} fullLayout/>
                    <AppRoute path="/search" component={Search} fullLayout/>
                    <AppRoute path="/articles/:slug" component={Articles} fullLayout/>
                    <AppRoute path="/articles" component={Articles} fullLayout/>
                    <AppRoute path="/article" component={Article} fullLayout/>
                    {/*<AppRoute path="/how-to-buy" component={HowToBuy} fullLayout/>*/}
                    <AppRoute path="/rules" component={Rules} fullLayout/>
                    <AppRoute path="/about-us" component={about_us} fullLayout/>
                    <AppRoute path="/contact-us" component={contact_us} fullLayout/>
                    <AppRoute path="/gallery" component={gallery} fullLayout/>

                    {/*System Panel*/}
                    <AppRoute path="/system/dashboard" permission="system" component={SystemDashboard}/>
                    <AppRoute path="/system/categories" permission="system" component={SystemCategories}/>
                    <AppRoute path="/system/sections" permission="system" component={SystemSections}/>
                    <AppRoute path="/system/menu" permission="system" component={SystemMenu}/>
                    <AppRoute path="/system/slider" permission="system" component={SystemSlider}/>
                    <AppRoute path="/system/article-category" permission="system" component={AdminArticleCategory}/>
                    <AppRoute path="/system/article" permission="system" component={AdminArticle}/>
                    <AppRoute path="/system/products" permission="system" component={AdminProducts}/>
                    <AppRoute path="/system/product/view" permission="system" component={AdminProductCreateAndEdit}/>
                    <AppRoute path="/system/code_editor" permission="system" component={SystemCodeEditor}/>

                    {/*Admin Panel*/}
                    <AppRoute path="/admin/dashboard" permission="admin" component={AdminDashboard}/>
                    <AppRoute path="/admin/customers" permission="admin" component={AdminCustomers}/>
                    <AppRoute path="/admin/seller" permission="admin" component={AdminSeller}/>
                    <AppRoute path="/admin/orders" permission="admin" component={AdminOrders}/>
                    <AppRoute path="/admin/invoices" permission="admin" component={AdminInvoices}/>
                    <AppRoute path="/admin/products" permission="admin" component={AdminProducts}/>
                    <AppRoute path="/admin/product/view" permission="admin" component={AdminProductCreateAndEdit}/>
                    <AppRoute path="/admin/product/variety" permission="admin" component={AdminProductVariety}/>
                    <AppRoute path="/admin/prices" permission="admin" component={AdminPrices}/>
                    <AppRoute path="/admin/coupons" permission="admin" component={AdminCoupons}/>
                    <AppRoute path="/admin/send-goods" permission="admin" component={AdminSendGoods}/>
                    <AppRoute path="/admin/profile" permission="admin" component={AdminProfile}/>
                    <AppRoute path="/admin/contactForm" permission="admin" component={AdminContactForm}/>
                    <AppRoute path="/admin/comments" permission="admin" component={AdminComments}/>
                    <AppRoute path="/admin/article-category" permission="admin" component={AdminArticleCategory}/>
                    <AppRoute path="/admin/article" permission="admin" component={AdminArticle}/>
                    <AppRoute path="/admin/categories" permission="admin" component={SystemCategories}/>
                    <AppRoute path="/admin/gallery" permission="admin" component={galleryPanel}/>
                    <AppRoute path="/admin/stories" permission="admin" component={AdminStroies}/>


                    {/*Seller Panel*/}
                    <AppRoute path="/seller/dashboard" permission="seller" component={SellerDashboard}/>
                    <AppRoute path="/seller/products" permission="seller" component={SellerProducts}/>
                    <AppRoute path="/seller/product/view" permission="seller" component={SellerProductCreateAndEdit}/>
                    <AppRoute path="/seller/product/variety" permission="seller" component={SellerProductVariety}/>
                    <AppRoute path="/seller/orders" permission="seller" component={SellerOrders}/>

                    {/*Customer Panel*/}
                    <AppRoute path="/customer/dashboard" permission="customer" component={CustomerDashboard}/>
                    <AppRoute path="/customer/interest" permission="customer" component={CustomerInterest}/>
                    <AppRoute path="/customer/orders" permission="customer" component={CustomerOrders}/>
                    <AppRoute path="/customer/comments" permission="customer" component={CustomerComments}/>
                    <AppRoute path="/customer/address" permission="customer" component={CustomerAddress}/>
                    <AppRoute path="/customer/profile" permission="customer" component={CustomerProfile}/>
                    <AppRoute path="/customer/invoices" permission="customer" component={CustomerInvoices}/>

                    <AppRoute component={error404} fullLayout/>
                </Switch>
            </Router>
        )
    }
}

export default connect(mapStateToProps, {getPing, getUI})(AppRouter);
